<div class="align-center-item page-not-found text-center">
  <div class="error-code">404</div>
  <h2>{{'Page not found' | translate}}</h2>
  <button routerLink="/" class="btn btn-primary">{{'Back To Dashboard' | translate}}</button>
</div>
